import { generateAppendixCMessage } from '../blurbs';

import type { IAppendixCValues, IUseAppendixCProps } from '../types';

export const useAppendixC = ({
  closeModal,
  handleSubmit,
}: IUseAppendixCProps) => {
  const initialValues: IAppendixCValues = {
    whichPerson: '',
    otherPerson: '',
    callType: '',
    callTypeExtra: [],
    reasonForCall: [],
    otherDetails: '',
  };

  const preparedData = (data: IAppendixCValues) => {
    const formData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== null),
    );

    return {
      whichPerson: formData.whichPerson,
      otherPerson: formData.otherPerson,
      callType: formData.callType,
      callTypeExtra: formData.callTypeExtra,
      reasonForCall: formData.reasonForCall,
      otherDetails: formData.otherDetails,
    };
  };

  const onSaveForm = (formData: IAppendixCValues) => {
    const preparedValues = preparedData(formData);

    const filteredValues = Object.fromEntries(
      Object.entries(preparedValues).filter(([_, value]) => value !== null),
    ) as IAppendixCValues;
    const message = generateAppendixCMessage(filteredValues);

    handleSubmit(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
